export const CustomEn = {
  TITLE: "Code",
  BLOCKS: "Blocks",
  LINKTOOLTIP: "Save and link to blocks.",
  RUNTOOLTIP: "Run the program defined by the blocks in the workspace.",
  BADCODE: "Program error:\n%1",
  TIMEOUT: "Maximum execution iterations exceeded.",
  TRASHTOOLTIP: "Discard all blocks.",
  CATLOGIC: "Logic",
  CATLOOPS: "Loops",
  CATMATH: "Math",
  CATALGEBRA: "Algebra",
  CATANALYSIS: "Analysis",
  CATARITHMETIC: "Arithmetic",
  CATGEOMETRY: "Geometry",
  CATMATRIX: "Matrix",
  CATSTATS: "Stats",
  CATLANG: "Lang",
  CATFRENCH: "French",
  CATTEXT: "Text",
  CATLISTS: "Lists",
  CATCOLOUR: "Colour",
  CATVARIABLES: "Variables",
  CATFUNCTIONS: "Procedures",
  CATMEDIA: "Media",
  LISTVARIABLE: "list",
  TEXTVARIABLE: "text",
  HTTPREQUESTERROR: "There was a problem with the request.",
  LINKALERT: "Share your blocks with this link:\n\n%1",
  HASHERROR: "Sorry, '%1' doesn't correspond with any saved program.",
  XMLERROR:
    "Could not load your saved file. Perhaps it was created with a different version of Blockly?",
  BADXML:
    "Error parsing XML:\n%1\n\nSelect 'OK' to abandon your changes or 'Cancel' to further edit the XML.",
  CATEXAMPLES: "Introduction",
  CATSTART: "Start",
  CATDISPLAY: "Display",
  CATQUESTIONS: "Question",
  CATAI: "AI",
  CATFEEDBACK: "Feedback",

  CATOBJECTS: "Objects",

  //LABEL SEPARATORS
  LABEL_START: "Start",
  LABEL_FORMATTING: "Formatting",
  LABEL_STYLES: "Styles",
  LABEL_EXPERT: "Expert",

  LABEL_NUMBERS: "Numbers",
  LABEL_CALCULUS: "Calculus",
  LABEL_ARITHMETICS: "Arithmetic",
  LABEL_FRACTIONS: "Fractions",
  LABEL_UNITS: "Units",

  LABEL_FUNCTIONS: "Functions",
  LABEL_TOOLS: "Tools",
  LABEL_GRAPHIC: "Graphic",

  LABEL_OBJECTS: "Objects",
  LABEL_TRANSFORMATIONS: "Transformations",
  LABEL_CALCULUSES: "Calculuses",
  LABEL_DISPLAY: "Display",

  LABEL_LIST_EXPERT: "Expert",
  LABEL_MATRIX_EXPERT: "Expert",

  //EXAMPLES CAT //Category dedicated for documentation
  EXAMPLES_PRINCIPLE_TITLE: "General principle of construction",
  EXAMPLES_PRINCIPLE_DOCUMENTATION: `The design of a basic activity is done with 3 main blocks:
  - A header block at the beginning of the activity
  - A Statement block underneath with a display block to show your statement
  - One or several question blocks
  Most blocks have fields pre-filled with default blocks or values. This is to guide you in building your activity. Of course these fields can be replaced by other types of blocks.`,

  //WORKSPACE
  DOWNLOAD_SCREENSHOT: "Download screenshot",
  DELETE_UNUSED_VARIABLES: "Delete unused variables",

  //START CAT
  //BLOCK INFO
  INFO_TITLE: "Activity",
  INFO_MESSAGE:
    "Activity title %1 lang %2 description %3 max attempts%4 default feedback%5",
  INFO_LANG_TOOLTIP: `Type two letters lang code (e.g : "fr" for French, "en" pour English...)`,
  INFO_TOOLTIP: `The Header block of an activity. It must be placed at the beginning of the activity.
    - title : the title of the activity
    - descrition: short description of the activity.
    - default feedback: corresponds to an automatic and global feedback to the activity. It is mainly useful when the activity includes several questions. In this case, the feedback will indicate success in all questions or failure in at least one of them,`,
  INFO_COMMENT:
    "Comment here how your code works to help others understand and adapt it.",

  //LANG
  LANG_MATRIX_TITLE: "Activity (Multilingual)",
  LANG_MATRIX_MAX_ATTEMPTS: "max attempts",
  LANG_MATRIX_DEFAULT_FEEDBACK: "default feedback",
  LANG_MATRIX_ACTIVITY_TITLE: "TITLE               ",
  LANG_MATRIX_DESCRIPTION: "DESCRIPTION",
  LANG_MATRIX_LANG: "LANG               ",
  LANG_MATRIX_KEY: "KEY",
  LANG_MATRIX_DEFAULT_TEXT: "Text",
  LANG_MATRIX_CODE: "",
  LANG_MATRIX_TOOLTIP: `A table for designing activities in multiple languages.
  It is placed separately and above the other blocks in the design space to be loaded first.
  Each row contains a keyword followed by its translations in each column.
  Each column corresponds to a language code. The first column is the default language.
  Eleda automatically detects the language of the browser and will display the word or phrase corresponding to the keyword
  `,

  //LANG_TEXT
  LANG_TEXT_TITLE: "Texte multilingual",
  LANG_TEXT_MESSAGE: "text with key %1",
  LANG_TEXT_NOTFOUND: "ref not found",
  LANG_TEXT_TOOLTIP:
    "Returns the string corresponding to the key and the language defined by the browser",

  //BLOCK STATEMENT
  STATEMENT_TITLE: "Statement",
  STATEMENT_MESSAGE: "statement %1",
  STATEMENT_TOOLTIP: `Contains all the elements to be displayed in the statement.
    Contains most of the time "Display" blocks.`,
  //BLOCK DISPLAY_ELEMENT
  DISPLAY_ELEMENT_TITLE: "Display",
  DISPLAY_ELEMENT_MESSAGE: "Display %1",
  DISPLAY_ELEMENT_LEFT_ALIGN: "left aligned",
  DISPLAY_ELEMENT_CENTER_ALIGN: "centered",
  DISPLAY_ELEMENT_RIGHT_ALIGN: "right aligned",
  DISPLAY_ELEMENT_JUSTIFY_ALIGN: "justified",
  DISPLAY_ELEMENT_TOOLTIP: `Allows you to display elements in a "Statement".
    Most often included in the "Statement" block. 
    Contains all types of blocks: geometrical figures, math, graphics, texts...
    In case of it contains geometrical figures, a default graph with the limits Xmin:0, Ymax:10, Xmax:10, Ymin:0 will be drawn. 
    It also allows during the design phase to quickly check the different values and variables of the activity (debugging)`,
  //PARAGRAPH (RICHTEXT)
  RICHTEXT_CREATE_WITH_TITLE: "rich text",
  RICHTEXT_CREATE_WITH_INPUT_WITH: "create a paragraph with ",
  RICHTEXT_CREATE_WITH_TOOLTIP: `Allows you to create a paragraph by combining elements in order to display them.
    Returns a paragraph with a list of objects to display.
    Most often included in a "Display" block.
    Contains most often blocks of type "Text", "LaTeX", "Markdown", "Geometry", "Nested question".`,

  //LATEX_PARAGRAPH (RICHTEXT)
  LATEX_PARAGRAPH_CREATE_WITH_TITLE: "LaTeX assembling",
  LATEX_PARAGRAPH_CREATE_WITH_INPUT_WITH: "create a LaTeX assembling with ",
  LATEX_PARAGRAPH_CREATE_WITH_TOOLTIP: `Allows you to combine LaTeX texts with other Eleda blocks in order to display them nested.
    Returns a LateX paragraph ready to be displayed.
    Most often included in a "Display" block.
    Contains most often blocks of type "Text" (with LaTeX string), "Nested question", "Geometry"`,

  //ALIGNMENT  COLOUR RANDOM_COLOUR SIZE
  SET_ALIGNMENT_TOOLTIP:
    "Aligns the block to left, center or right. Contains most often a paragraph block.",
  SET_COLOUR_TOOLTIP:
    "Applies a colour to a block. This block can be applied to many block types (text, geometry etc).",
  SET_COLOUR_RANDOM_TOOLTIP:
    "Applies a random colour to a block. This block can be applied to many block types (text, geometry etc).",
  SET_SIZE_TOOLTIP:
    "Applies a size to a block. This block can be applied to many block types (text, question, geometry etc).",
  SET_ATTRIBUTE_MESSAGE: "set %1 with %2",
  SET_ATTRIBUTE_TOOLTIP:
    "Advanced : This block allows to apply specific parameters to some blocks (see Documentation).",
  SET_ATTRIBUTE_DOCUMENTATION: `Advanced: This block can contain different types of blocks and apply specific properties to them in JSON format.
    This block can contain the following blocks and apply the following parameters to them:
    - Mathematical blocks (algebraic expression ...):
    • 'smartDisplay' : "true" by default. Try to simplify and transform a mathematical expression as well as possible.  
    - Geometry blocks (polygons, circles ...): 
    • 'fillColor' to fill a figure with a color determined by its hexadecimal code (for example '#ff0000') or by 'random'
    • 'dash' to set a dashed pattern. Value must be between 0 and 6. (0: solid line, 1: dotted line, 3: line with normal dashes ...)
    • 'group' to group the points of a polygon, enabling complete translation of the polygon by moving any of its vertices.
    - Data table block : 'isBordered' (true by default) allows to display or not the cells borders, 'isStriped' (true by default) allows to grey out every other line, 'isHoverable' (false by default) allows to light up the lines when the mouse passes over them
    `,

  //BLOCK MARKDOWN
  MARKDOWN_TITLE: "markdown",
  MARKDOWN_MESSAGE: "markdown %1",
  MARKDOWN_TOOLTIP: `Allows you to use Markdown notation.
    Returns an HTML object to display  
    Most often included in a "Display" block.
    Contains only "Text" blocks and interprets Markdown characters.

    - Examples: start a line with # to display a level 1 title, with ## for a level 2 title, surround a word with two ** to put it in bold ...
`,
  //BLOCK LATEX
  LATEX_TITLE: "LaTeX",
  LATEX_MESSAGE: "LaTeX %1",
  LATEX_TOOLTIP: `Allows you to use LaTeX notation.
    Returns an HTML object to display    
    Most often included in a "Display" block.
    Contains only "Text" blocks and interprets LaTeX notation.  LaTeX is a very powerful language to display scientific texts and formulas in an elegant way. Expressions must be prefixed by "\\".
    To know more about it : consult the documentation`,

  LATEX_DOCUMENTATION: `Allows you to use LaTeX notation.
    Returns an HTML object to display    
    Most often included in a "Display" block.
    Contains only "Text" blocks and interprets LaTeX notation.  LaTeX is a very powerful language to display scientific texts and formulas in an elegant way. Expressions must be prefixed by "\\".
    
    - Example 1 : \\dfrac{ax+b}{b} in a "LaTeX" block contained in a "Display" block displays a fraction.
    - Example 2 : \\textrm{The element } u_2 \\textrm{ is the second element of the sequence } u_n for mixing text in Latin and math
    - Example 3 : f(n)=\\begin{cases} n/2, & \\mbox{if }n is even} \\\\ 3n+1, & \\mbox{if }n\\mbox{ is odd} \\end{cases}
`,
  //BLOCK SPECIAL_CHARACTER
  SPECIAL_CHARACTER_TOOLTIP: "Breaks a line or adds horizontal line separator",

  //BLOCK VERSION
  VERSION_MESSAGE: "Create the versions of the activity with",
  VERSION_DEFAULTVERSION: "default version",
  VERSION_VERSIONN: "version no.",
  VERSION_LABEL: " having the label",
  VERSION_TOOLTIP: "Allows the creation of a multi-version activity.",

  CLEAN_ACTIVITY_MESSAGE: "Clear all activity content (beta)",
  CLEAN_ACTIVITY_TOOLTIP:
    "Clears all content of an activity. Often used in feedback to allow you to clear the history of previous statements, questions and feedback and display new information.",

  //BLOCK QUESTIONS
  //COMMON STRINGS CONTAINED IN QUESTION BLOCKS
  QUESTION_WARNING_NESTED_QUESTIONS:
    "Warning : For nesting questions, you have to set, in the hat block, the value 'max attempts' to 1.",

  QUESTION_GENERAL_MORE_OPTIONS_NB_PROPOSALS: "number of proposals to display",
  QUESTION_GENERAL_MORE_OPTIONS_DEFAULT_FEEDBACKS: "default feedback",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY: "display",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_EXTERNAL: "external",
  QUESTION_GENERAL_MORE_OPTIONS_DISPLAY_INLINE: "nested",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN:
    "learner's answer stored in",
  QUESTION_GENERAL_MORE_OPTIONS_LEARNERANSWER_SAVEIN_NAMEVAR: "answer",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN: "question stored in",
  QUESTION_GENERAL_MORE_OPTIONS_QUESTION_SAVEIN_NAMEVAR: "question",
  QUESTION_GENERAL_MORE_OPTIONS_FEEDBACKS: "⏎ feedback",
  //BLOCK QUESTION_TRUE_FALSE
  QUESTION_TRUE_FALSE_TRUE: "true",
  QUESTION_TRUE_FALSE_FALSE: "false",
  QUESTION_TRUE_FALSE_TITLE: "Question: answer by true or false",

  QUESTION_TRUE_FALSE_MESSAGE:
    "❓ True/False question %1 text %2 ✅ correct answer %3 %4 advanced settings",
  QUESTION_TRUE_FALSE_TOOLTIP: `Request to confirm or deny a proposal.
    - Text: it contains the text of the proposition or an instruction.
    - Right answer: True or false. It can be directly the logical element true or false, or contain the result of a more complex logical test.
    To know more about it: consult the documentation.`,

  QUESTION_TRUE_FALSE_DOCUMENTATION: `Request to confirm or deny a proposal.
   - Text: it contains the text of the proposition or an instruction.
   - Right answer: True or false. It can be directly the logical element true or false, or contain the result of a more complex logical test.
  
    Advanced settings :
    - Display: the "external" option allows to display the question after the statement; the "nested" option allows to display the question within the statement.
    - Answer stored in: allows you to choose the variable that will store the learner's answer corresponding to a boolean (true or false).
    - Default feedback: allows you to activate or not the display of the standard pass/fail message for the question.
    - Feedback: contains "Feedback" blocks that allow triggering feedback related to this question and according to the learner's answer.
    
    Raw settings (JSON) contains specific settings (to be provided in JSON format) :
    - feedbackcolor (boolean) : "true" by default. If "false", the learner's response zone is not anymore colored according to his answer.
    - grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    `,

  //BLOCK MULTIPLE_CHOICES_QUESTION
  QUESTION_MULTIPLE_CHOICES_TITLE: "Multiple choice question",

  QUESTION_MULTIPLE_CHOICES_MESSAGE:
    "❓ Multiple Choice Question %1 type %2 %3 text %4 ✅ correct answer(s) %5 ❌ wrong answers %6 %7 advanced settings",

  QUESTION_MULTIPLE_CHOICES_MULTIPLE: "several correct answers",
  QUESTION_MULTIPLE_CHOICES_UNIQUE: "one correct answers",

  QUESTION_MULTIPLE_CHOICES_TOOLTIP: `Asks you to choose one or more answers from a set of propositions.
    - Type: allows you to define a single-choice or multiple-choice MCQ.
    - Text: it contains the text of the proposition or an instruction.
    - Correct answers: list of answers considered as correct.
    - Wrong answers: List of answers considered wrong.
    For more information: consult the documentation.`,

  QUESTION_MULTIPLE_CHOICES_DOCUMENTATION: `Asks you to choose one or more answers from a set of propositions.
    - Type: allows you to define a single-choice or multiple-choice MCQ.
    - Text: it contains the text of the proposition or an instruction.
    - Correct answers: list of answers considered as correct.
    - Wrong answers: List of answers considered wrong.

    Advanced settings :
    - Number of proposals to display : Leave blank to display all possibilities (right and wrong). If specified, allows choosing randomly a limited number of propositions to be presented to the learner among all the right and wrong answers. In a 'single choice' MCQ, the right answer will always be proposed. In a multiple-choice MCQ, it is possible that only incorrect answers are proposed; in this case the learner will not have to check anything to be correct.
    - Display : the option "external" allows displaying the question after the statement; the option "nested" allows displaying the question within a statement.
    - Answer stored in: allows you to choose the variable that will store the learner's answer. The variable will contain the list of items checked by the learner.
    - Default Feedback: Allows you to enable or disable the display of the standard pass/fail message for the question.
    - Feedback: contains "Feedback" blocks that allows you to trigger feedback related to this question and according to the learner's answer.
    
    Raw settings (JSON) contains specific settings (to be provided in JSON format) :
    - feedbackcolor (boolean) : "true" by default. If "false", the learner's response zone is not anymore colored according to his answer.
    - grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    `,

  //BLOCK QUESTION_OPEN
  //=> ajouter var glob pour les inputs
  QUESTION_OPEN_TYPE_INTEGER_POSITIVE: "positive integer",
  QUESTION_OPEN_TYPE_INTEGER: "integer",
  QUESTION_OPEN_TYPE_DECIMAL: "decimal",
  QUESTION_OPEN_TYPE_FRACTION: "fraction",
  QUESTION_OPEN_TYPE_TEXT: "text",
  QUESTION_OPEN_TYPE_EXPRESSION: "mathematical expression",
  QUESTION_OPEN_TYPE_LIST: "list or matrix (available soon)",
  QUESTION_OPEN_OPTION_TITLE: "raw settings (JSON)",

  QUESTION_OPEN_TITLE: "Open question",

  QUESTION_OPEN_MESSAGE:
    "❓ Open Question %1 text %2 expected answer type %3 %4 ✅ correct answer %5 %6 advanced settings",
  QUESTION_OPEN_TOOLTIP: `Request to give a value of a certain type.
    - Text: contains the text of the proposal or an instruction.  
    - Type of expected answer: corresponds to the type of expected value.
    - Correct answer: The value corresponding to the correct answer. It can be directly the value, a variable or contain the result of a more complex calculation.
    To know more about it : consult the documentation.`,

  QUESTION_OPEN_DOCUMENTATION: `Request to give a value of a certain type.
    - Text: contains the text of the proposal or an instruction.
    - Type of expected answer: corresponds to the type of expected value.
    - Text: the expected answer is a text. To be considered as correct, the answer given must be entered exactly as the correct answer (respecting upper and lower case, accents...). Finer tuning will be implemented soon to take into account or not case, accents, superfluous spaces, spelling mistakes...
    - Integer or positive integer : the expected answer is an integer, the numerical value (Integer) corresponding to the correct answer. It can be directly the value, a variable or contain the result of a more complex calculation.
    - Decimal : the expected answer is a decimal number. To be considered as correct, the answer must not be rounded. Finer tuning will be implemented soon to take into account the precision (number of significant digits)...
    - Fraction : the expected answer is a fraction. To be considered as correct, the answer must be entered as an irreducible fraction.
    - Expression : the expected answer is a symbolic expression (ex : 3x+2). To be considered as correct, the answer given must be equivalent (ex : 2+3*x)
    - List or Matrix : the expected answer is a list or a matrix entered in the form [[1,2],[3,4]].
    - Correct answer : The value corresponding to the correct answer. It can be directly the value, a variable or contain the result of a more complex calculation.

    Advanced settings :
    - Display: the option "external" allows displaying the question after the statement; the option "nested" allows displaying the question within the statement.
    - Answer stored in: allows you to choose the variable that will store the answer entered by the learner.
    - Default feedback: allows you to activate or not the display of the standard message of success or failure to the question.
    - Feedback: contains "Feedback" blocks that allow you to trigger feedback for this question based on the learner's response.

    Raw settings (JSON) contains specific settings (to be provided in JSON format) :

    - For all expected answer types: 
    • feedbackcolor (boolean) : "true" by default. If "false", the learner's response zone is not anymore colored according to his answer.
    • grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    • emptyMeansZero (boolean) : "false" by default. If "true", an empty answer is considered as a 0.
    • callbackSolution (boolean) : "false" by default. If "true", correct answer must be a procedure returning a boolean instead of a value. This custom procedure returned true or false depending on your learner's answer analysis.
    • length (number) :  Only enabled with nested open questions. 10 by default, it corresponds approximatively to the number of characters displayable in the input field.

    - For the Text, Integer, and Decimal expected answer types: 
    • maxLength (number) :  Only enabled with nested open questions. illimited by default, it limits the number of characters that can be entered in the input field.

    - For the Text type : 
    • caseSensitive (boolean) : "false" by default. If "true", answer must respect UpperCase/LowerCase to be considered as right.
    • spaceSensitive (boolean) : "false" by défault. If "true", answer must not contain extra spaces to be considered as right.

    - For the decimal type : 
    • precision (integer) : defines at how many decimal digits the answer must be rounded to be considered as right.

    - For the Fraction type : 
    • irreducibleFraction (boolean) : "false" by default. If "true", answer must be irreductible to be considered as right.


    Example if Text type is chosen :
    { "caseSensitive" : true, "spaceSensitive" : true}
    considers answer as right, if it respects UpperCases/LowerCasses and contains no extra spaces.
  `,
  //BLOCK QUESTION_REORDER
  QUESTION_REORDER_TITLE: "Question: reorder elements",
  QUESTION_REORDER_TEXT: "Order the elements",
  QUESTION_REORDER_MESSAGE:
    "❓ Question Reorder %1 text %2 ✅ List to reorder %3 %4 Advanced settings",
  QUESTION_REORDER_TOOLTIP: `Request to reorder elements between them.
    - List to reorder: The list of correctly ordered elements.
    For more information: see the documentation.`,

  QUESTION_REORDER_DOCUMENTATION: `Request to reorder elements between them.
    - List to reorder: The list of correctly ordered elements.
  
    Advanced settings :
    - Number of proposals to display: Leave empty to display all the items in the list to reorder. If specified, allows you to randomly choose a limited number of proposals to present to the learner.
    - Answer stored in: allows you to choose the variable that will store the learner's answer. The variable will contain the list of elements whose positions are correct. By deduction the wrongly positioned elements will be found.
    - Default feedback: allows activating or not the display of the standard message of success or failure to the question.
    - Feedback: contains "Feedback" blocks that allow triggering feedback related to this question and according to the learner's answer.
 
    Raw settings (JSON) contains specific settings (to be provided in JSON format) :
    - grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    `,

  //BLOCK QUESTION_ASSOCIATE
  QUESTION_ASSOCIATE_TITLE: "Question: associate elements",
  QUESTION_ASSOCIATE_TEXT: "Associate the elements",
  QUESTION_ASSOCIATE_MESSAGE:
    "❓ Question Associate %1 text %2 ✅ Element list %3 ✅ Feature list %4 %5 Advanced settings",
  QUESTION_ASSOCIATE_TOOLTIP: `Requires associating elements with their features. Each element must have a unique feature.
    - Elements: The list of elements.
    - Features: The list of features of the corresponding elements.
    The element in index 'i' of the elements list has the feature in index 'i' of the feature list.
    For more information: see the documentation.
    `,

  QUESTION_ASSOCIATE_DOCUMENTATION: `Requires associating elements with their features. Each element must have a unique feature.
    - Elements: The list of elements.
    - Features: The list of features of the corresponding elements.
    The element in index 'i' of the elements list has the feature in index 'i' of the feature list.
  
    Advanced settings:
    - Stores the learner's answer in: allows you to choose the variable that will store the learner's answer. The variable will contain the list of elements correctly associated with their characteristic,
    - Number of proposals to display: Leave blank to display all the items and their characteristics. If specified, allows a limited number of elements to be randomly selected with their characteristics.
    - Default feedback: Allows activating or not the display of the standard message of success or failure to the question.
    - Feedback: contains "Feedback" blocks that allow triggering feedback related to this question and according to the learner's answer.
    
    Raw settings (JSON) contains specific settings (to be provided in JSON format) :
    - grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    `,

  //BLOC QUESTION_FIGURE
  QUESTION_FIGURE_TITLE: "Question on geometry",
  QUESTION_FIGURE_MESSAGE:
    "❓ Question on graphic %1 graphic concerned %2 %3 ✅ good answer condition %4 %5 advanced settings",
  QUESTION_FIGURE_TOOLTIP: `Request to interact with a graphic (move points, build geometric figure...).
    - Graphic concerned : graphic variable name variable.
    - good answer condition : boolean resulting from a test (for instance test point's cordinates).
    `,

  QUESTION_FIGURE_DOCUMENTATION: `Request to interact with a graphic (move points, build geometric figure...).
    - Graphic concerned : graphic variable name variable.
    - good answer condition : boolean resulting from a test (for instance test point's cordinates).
   
    Raw settings (JSON) contains specific settings (to be provided in JSON format) :
    - grade (boolean) : "true" by default. If "false", the "Define grade manually" block will set the learner's grade when a sequence is completed.
    `,

  //BLOCK FEEDBACK
  FEEDBACK_TITLE: "feedback",
  FEEDBACK_MESSAGE: "⏎ Feedback (deprecated) %1 if %2 displays %3",
  FEEDBACK_TOOLTIP: `Allows displaying messages according to logical tests.
    - if: corresponds to the logical test that triggers the display of the text. Most often the logical test is performed on the variable that records the learner's answer.
    - displays: The text to display if the test is true. Any displayable element can be chosen (texts, graphics, ...).`,

  //CATEGORY FEEDBACK

  //BLOCK FEEDBACK_MESSAGE_TYPE
  FEEDBACK_MESSAGE_TYPE_MESSAGE: "Set feedback message tone to %1",
  FEEDBACK_MESSAGE_TYPE_KIDS: "Children/Teens",
  FEEDBACK_MESSAGE_TYPE_NEUTRAL: "Neutral",
  FEEDBACK_MESSAGE_TYPE_FORMAL: "Formal",
  FEEDBACK_MESSAGE_TYPE_TOOLTIP: `Choose the tone used for feedback messages to be displayed. 
  The tone of feedback messages can be neutral, child/teen-oriented or adult-oriented (formal). 
  By default, the tone of feedback messages is neutral.`,

  //BLOCK FEEDBACK GLOBAL
  FEEDBACK_GLOBAL_TITLE: "global feedback",
  FEEDBACK_GLOBAL_MESSAGE: "global feedback %1",
  FEEDBACK_GLOBAL_TOOLTIP:
    "Contains all blocks to trigger feedback depending on this activity and all its questions. Most of the time, global feedback is function of learners' answers.",

  //PSEUDO BLOCKS
  FEEDBACK_LOCAL_TITLE: "Example",
  FEEDBACK_GLOBAL_EXAMPLE_DOCUMENTATION: `This set is a pre-built example to be integrated at the end of an activity.
Depending on the learner's answers to the questions, a personalized message is displayed.`,
  FEEDBACK_TEST_ATTEMPTS_DOCUMENTATION: `This set is a pre-built example to be included in the advanced settings of a question block or global feedback block.
            It provides a simple way to test the current learner's attempt or remaining learner's attempts. Thus, you can design a progressive feedback by taking into account the amount of attempts consumed.`,
  //BLOCK ISSOLUTIONFOUND
  FEEDBACK_IS_SOLUTION_FOUND: "solution is found to this question",
  FEEDBACK_ARE_ALL_SOLUTIONS_FOUND: "solutions are found to all questions ",
  FEEDBACK_IS_SOLUTION_FOUND_TOOLTIP: `must be used within a question's feedback or within global feedback block.
  - solution to this question found: returns true if the solution to question has been found.
  - all solutions to activity's questions found: returns true if all solutions to activity's questions have been found.`,

  //BLOCK CURRENT_ATTEMPT
  FEEDBACK_CURRENT_ATTEMPT_MESSAGE: "learner's current attempt",
  FEEDBACK_CURRENT_ATTEMPT_TOOLTIP: `must be used within a question's feedback or within global feedback block.
  - returns an integer corresponding to the number of learner's current attempt.`,

  //BLOCK MAX_ATTEMPTS
  FEEDBACK_MAX_ATTEMPTS_MESSAGE: "activity's max attempts",
  FEEDBACK_MAX_ATTEMPTS_TOOLTIP: `must be used within a question's feedback or within global feedback block.
  - returns an integer corresponding to the number of max attempts declared in this activity.`,

  //BLOCK MESSAGE
  FEEDBACK_MESSAGE_TOOLTIP: "Returns a predefined feedback message.",
  FEEDBACK_MESSAGE_MESSAGE: "message",
  FEEDBACK_MESSAGE_SOLUTION_FOUND_ATFIRSTATTEMPT:
    "Solution found at first attempt",
  FEEDBACK_MESSAGE_SOLUTION_FOUND: "Solution found",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND_BUTREMAININGATTEMPTS:
    "Solution not found but remaining attempts",
  FEEDBACK_MESSAGE_SOLUTION_NOTFOUND: "Solution not found",

  CONTEXT_QUESTION_MESSAGE: "In the context of the question %1 %2 %3",
  CONTEXT_QUESTION_TOOLTIP:
    "Allows you to work in the context of a question. Useful to externalize in a procedure question's feedback.",

  SET_GRADE_MESSAGE: "Stop the activity and set the grade to %1%",
  SET_GRADE_TOOLTIP:
    "This block manually sets a grade for the activity and ends up the activity. This grade will be recorded in the statistics of a sequence and will replace the default one.",

  SET_ANALYTIC_MESSAGE: "Register a learning analytic with key %1 and value %2",
  SET_ANALYTIC_TOOLTIP:
    "This block allows to register a learning analytic defined by a key and a value. This analytic allows to register values during the activity execution by a learner. The analytic's value will then be available in the sequence's statistics.",

  //BLOCK IA
  IA_TITLE: "AI",
  IA_MESSAGE: "AI (coming soon...) %1",
  IA_TOOLTIP: "Artificial Intelligence functions will be implemented soon.",

  //MATH ARITHMETIC
  RANDOM_NUMBER_MESSAGE: "🎲 random %1 between%2 and %3",
  RANDOM_NUMBER_INTEGER: "integer",
  RANDOM_NUMBER_DECIMAL: "decimal",
  RANDOM_NUMBER_TOOLTIP:
    "Returns a random number (integer or decimal) larger or equal to min and strictly smaller than max using a uniform distribution.",
  //BLOCK ROUND_DECIMAL
  ROUND_DECIMAL_MESSAGE: "rounding from %1 to %2 decimals",
  ROUND_DECIMAL_TOOLTIP: "Returns the rounding of a number to n decimals.",

  //BLOCK INTEGER_DECIMAL_PART
  INTEGER_DECIMAL_PART_MESSAGE: "%1 %2",
  INTEGER_DECIMAL_PART_INTEGER: "integer part",
  INTEGER_DECIMAL_PART_DECIMAL: "decimal part",
  INTEGER_DECIMAL_PART_TOOLTIP: "Returns integer or decimal part of a number.",

  //BLOCK SPLIT_NUMBER
  SPLIT_NUMBER_MESSAGE: "split number %1 into digits",
  SPLIT_NUMBER_TOOLTIP: "Returns the list of a number's digits",

  ///////////////////REPLACED BY UPON
  //BLOCK INTEGER_PART
  INTEGER_PART_MESSAGE: "integer part of %1",
  INTEGER_PART_TOOLTIP: "Returns integer part of a number.",
  //BLOCK DECIMAL_PART
  DECIMAL_PART_MESSAGE: "decimal part of %1",
  DECIMAL_PART_TOOLTIP: "Returns decimal part of a number.",

  ////////////////////////
  //BLOCK GCD_LCM
  GCD_LCM_OPERATOR_GCD: "GCD",
  GCD_LCM_OPERATOR_LCM: "LCM",
  GCD_LCM_MESSAGE: "%1 of list %2",
  GCD_LCM_TOOLTIP: "Returns GCD or LCM of all the numbers in the list.",

  /////////////////////
  //MATH GEOMETRY
  //BOARD
  BOARD_TITLE: "graphic",
  BOARD_GEOMETRIC_MESSAGE:
    "📈 Graphic Xmin%1 Xmax%2 Ymin%3 Ymax%4 ⊞%5 %6 %7▦ %8 %9🕹",
  BOARD_SIZE_SMALL: "small",
  BOARD_SIZE_MEDIUM: "medium",
  BOARD_SIZE_BIG: "big",

  BOARD_AXES_XY: "X & Y",
  BOARD_AXES_X: "X only",
  BOARD_AXES_Y: "Y only",
  BOARD_AXES_NONE: "None",

  BOARD_TOOLTIP: `
  Creates a graph according to the selected upper and lower limits with or without displaying the axes and with or without a grid.
  Most often followed by Draw blocks which draw different geometric elements in the graph.
  Can also be included in a Size Block to change the graph size.
  `,
  //DRAW
  DRAW_MESSAGE: "Draw %1", //OBSOLETE
  DRAW_IN_BOARD_MESSAGE: "draw %1 in the graphic%2",

  DRAW_TOOLTIP: `Draws a geometric element within a graphic.
    Contains graphic elements to be drawn in the graphic variable selected.
    Prior, a Graphic Bloc variable has to be set.`,

  //ERASE_IN_BOARD
  ERASE_MESSAGE: "Erase %1", //OBSOLETE
  ERASE_IN_BOARD_MESSAGE: "erase %1 in the graphic%2",
  ERASE_IN_BOARD_TOOLTIP: `Erases a geometric element within a graphic.
    Contains graphic element variable to be erased in the graphic variable selected.
    Prior, Figure and Graphic Bloc variables have to be set.`,
  //ERASE_IN_BOARD
  ERASE_ALL_BOARD_MESSAGE: "erase all elements in graphic%1",
  ERASE_ALL_BOARD_TOOLTIP: `Erases all geometric elements within a graphic.
    Contains graphic variable to be erased.
    Prior, Graphic Bloc variable has to be set.`,

  //BLOCK POLYGON
  POLYGON_MESSAGE: "polygon with vertices %1",
  POLYGON_TOOLTIP: `Returns a polygon of n vertices. To define a color, include it in a color block.
    Contains a list of vertices and a color
    Most often included in a "Draw" block.`,
  //POINT
  POINT_MESSAGE: "point %1 X%2 Y%3 %4 %5 options ",
  POINT_TOOLTIP_WITHLABEL: "draws point",
  POINT_TOOLTIP_SHOWINFOBOX: "displays coordinates",
  POINT_TOOLTIP_FIXED: "fixed or movable",
  POINT_TOOLTIP:
    "Returns a point with coordinates x and y. Options: cf documentation",
  POINT_DOCUMENTATION: `Returns a point with coordinates x and y.
  Options: 
  - 🔵 : draws point.
  - 💬 : displays the point's coordinates when the mouse overs it.
  - 🔒 : sets the point fixed or movable.
  - 🧲 : sets the attractors =>
  - An attractor can be an number : The point can only be placed on the abscissa and ordinate which are multiple of this number.
  - Un attractor can be a liste [a,b] : The point can only be placed on the abscissa which is multiple of a and the ordinate which is multiple of b.
  - Un attractor could be another figure : The point can only be placed on the ouline of this figure.`,

  //POINT COORDINATE
  FIGURE_COORDINATE_MESSAGE: "coordinate %1 of point saved in %2",
  FIGURE_COORDINATE_TOOLTIP: `Returns coordinate x or y of a point saved in a variable.
  Prior the point have to be saved in a variable.`,

  //LINE
  LINE_LINE: "line",
  LINE_SEGMENT: "segment",
  LINE_ARROW: "arrow",
  LINE_DOTTED: "dotted",
  LINE_MESSAGE: "%1 passing through%2 and%3",
  LINE_TOOLTIP: `Returns a line, a segment or an arrow passing through two points.`,

  //TANGENT
  TANGENT_MESSAGE: "tangent passing through %1",
  TANGENT_TOOLTIP: `Sends a tangent defined by a point with one or more attractors`,
  //CIRCLE
  CIRCLE_MESSAGE: "circle of center%1 and radius%2",
  CIRCLE_TOOLTIP: `Returns a circle defined by a point representing its center and radius.`,
  //DISK - SECTOR - CIRCLE PORTION
  SECTOR_MESSAGE:
    "circular sector with center%1 and defined by the point%2 and the point%3",
  SECTOR_TOOLTIP:
    "Returns a sector is defined by three points: The sector's center p1, a second point p2 defining the radius and a third point p3 defining the angle of the sector. The Sector is always drawn counter clockwise from p2 to p3",
  SECTOR_DOCUMENTATION: `Returns a sector is defined by three points: The sector's center p1, a second point p2 defining the radius and a third point p3 defining the angle of the sector. The Sector is always drawn counter clockwise from p2 to p3
  Advanced Parameters (Apply the Set block ... with ...) :
      • "arcOnly": true / false
      • "hasFirstArrow": true / false
      • "hasLastArrow": true / false
  `,
  //BOARD_TEXT
  BOARD_TEXT_MESSAGE: "text %1 positioned at %2",
  BOARD_TEXT_TOOLTIP:
    "Returns a text defined by a text and its position thanks to a point.",
  //BLOCK REGULARPOLYGON
  REGULARPOLYGON_MESSAGE:
    "regular polygon of center%1 with %2sides and radius%3",
  REGULARPOLYGON_TOOLTIP: `Returns a regular polygon defined by a point representing its center, its number of sides and its radius.`,

  //BLOCK RANDOMPOLYGON
  RANDOMPOLYGON_MESSAGE: "🎲 random polygon with %1 sides",
  RANDOMPOLYGON_TOOLTIP: `Returns a polygon with n vertices chosen randomly. The coordinates of the vertices are chosen in a default graph.`,
  //BLOCK RECTANGLE
  RECTANGLE_MESSAGE: "rectangle of length %1 %2 width %3 %4",
  RECTANGLE_TOOLTIP:
    "Returns a rectangle defined by its length, width and randomly positioned in a graph. The coordinates of the vertices are chosen in a default graph.",

  //BLOCK FIGURE_PERIMETER
  FIGURE_PERIMETER_MESSAGE: "perimeter of the figure %1",
  FIGURE_PERIMETER_TOOLTIP: `Returns the perimeter of the geometric figure
  Contains a geometric figure (rectangle, polygon, circle...).`,

  //BLOCK FIGURE_AREA
  FIGURE_AREA_MESSAGE: "area of the figure %1",
  FIGURE_AREA_TOOLTIP: `Returns the area of the geometric figure
  Contains a geometric figure (rectangle, polygon, circle...).`,
  //BLOCK FIGURE_TRANSFORMS
  FIGURE_ROTATE_MESSAGE: "rotate %1 by %2°",
  FIGURE_ROTATE_TOOLTIP: `Rotates a figure by an angle in degrees.`,
  FIGURE_TRANSLATE_MESSAGE: "translate %1 by [%2,%3]",
  FIGURE_TRANSLATE_TOOLTIP: `Translates a figure by vector [x,y].`,
  FIGURE_SCALE_MESSAGE: "scale %1 by [%2,%3]",
  FIGURE_SCALE_TOOLTIP: `Scale a figure by vector [x,y].`,
  //BLOCK EUCLIDEAN_DISTANCE_TWOPOINTS
  EUCLIDEAN_DISTANCE_TWOPOINTS_MESSAGE: "distance between %1 and %2",
  EUCLIDEAN_DISTANCE_TWOPOINTS_TOOLTIP: `Returns distance between two points.
    Contains two points' coordinates.`,

  //BLOCK EUCLIDEAN_DISTANCE
  EUCLIDEAN_DISTANCE_MESSAGE: "distance between x1%1 y1%2 and x2%3 y2%4",
  EUCLIDEAN_DISTANCE_TOOLTIP: `Returns distance between two points.
  Contains two points' coordinates.`,

  //BLOCK FIGURE_CLONE
  FIGURE_CLONE_MESSAGE: "clone of %1",
  FIGURE_CLONE_TOOLTIP: `Returns the clone of the geometric figure
  Contains a geometric figure (rectangle, polygon, circle...).`,

  //MATH ALGEBRA
  //BLOCK RANDOMPOLYNOM
  RANDOMPOLYNOM_MESSAGE: "🎲 random polynom of degree %1 with coefficients %2 ",
  RANDOMPOLYNOM_TOOLTIP: `Returns a random polynom of type expression expressed with variable 'x'. Example : x^2+2x-1.`,

  //BLOCK POLYNOM_WITH_COEFFICIENTS
  POLYNOM_WITH_COEFFICIENTS_MESSAGE: "polynom with the coefficients %1",
  POLYNOM_WITH_COEFFICIENTS_TOOLTIP: `Returns a polynom defined by a list of coefficients.`,

  //BLOCK GRAPH_OF_FUNCTION
  GRAPH_OF_FUNCTION_MESSAGE: "graph of f(x)= %1",
  GRAPH_OF_FUNCTION_TOOLTIP:
    "Returns the graphical representation of the function defined by a text or an expression.",

  //BLOCK GRAPH_OF_FUNCTION_INTERVAL
  GRAPH_OF_FUNCTION_INTERVAL_MESSAGE: "graph of f(x)= %1 on [ %2 , %3 ]",
  GRAPH_OF_FUNCTION_INTERVAL_TOOLTIP:
    "Returns the graphical representation of the function defined by a text or an expression in an interval",

  //BLOCK AREA_UNDER_FUNCTION_INTERVAL
  AREA_UNDER_FUNCTION_INTERVAL_MESSAGE: "area under f(x)= %1 on [ %2 , %3 ]",
  AREA_UNDER_FUNCTION_INTERVAL_TOOLTIP:
    "Returns the graphical representation of the area under the function defined by a text or expression in an interval.",

  //BLOCK EXPRESSION
  EXPRESSION_MESSAGE: "expression %1",
  EXPRESSION_TOOLTIP: "Returns an expression defined by a text (ex: 2*x+3).",
  //BLOCK DEGREE
  DEGREE_MESSAGE: "degree of polynom %1 with respect to %2",
  DEGREE_TOOLTIP:
    "Returns the degree of a polynom with respect to the defined variable",
  //BLOCK COEFFICIENTS
  COEFFICIENTS_MESSAGE: "coefficents list of a polynom %1 with respect to %2",
  COEFFICIENTS_TOOLTIP:
    "Returns the coefficients list (from lowest to greatest degree) of a polynom with respect to the defined variable",

  //PSEUDO BLOCK ADD POLYNOM
  COEFFICIENTS_OPERATOR_TOOLTIP:
    "Returns a new polynom which the addition of two polynoms. Also works with subtraction.",
  //BLOCK DERIVATIVE
  DERIVATIVE_MESSAGE: "derivative of %1 with respect to %2",
  DERIVATIVE_TOOLTIP:
    "Returns the derivative of an expression with respect to the defined variable.",
  //BLOCK PRIMITIVE
  PRIMITIVE_MESSAGE: "primitive of %1 with respect to %2",
  PRIMITIVE_TOOLTIP:
    "Returns the primitive of an expression with respect to the defined variable.",
  //INTEGRAL
  INTEGRAL_MESSAGE: "integral of %1 with respect to %2 over [ %3 , %4 ]",
  INTEGRAL_TOOLTIP:
    "Returns the integral of an expression with respect to the variable defined over an interval.",

  //BLOCK EVALUATE
  EVALUATE_MESSAGE: "value of %1 for %2=%3",
  EVALUATE_TOOLTIP:
    "Returns the evaluation of the expression for a variable name equals to a value.",
  //BLOCK SIMPLIFY
  SIMPLIFY_MESSAGE: "simplification of %1",
  SIMPLIFY_TOOLTIP: "Returns an expression into its simplified form.",
  //BLOCK EXPAND
  EXPAND_MESSAGE: "expansion of %1",
  EXPAND_TOOLTIP: "Returns an expression into its developed form.",
  //BLOCK UNIT
  UNIT_MESSAGE: "numeric value %1 unit %2",
  UNIT_TOOLTIP:
    "Returns an object Unit. It could be converted into another unit",
  UNIT_DOCUMENTATION: `Returns an object Unit. It could be converted into another unit.
    List of available units :
- Length 	meter (m), inch (in), foot (ft), yard (yd), mile (mi), link (li), rod (rd), chain (ch), angstrom, mil
- Surface area 	m2, sqin, sqft, sqyd, sqmi, sqrd, sqch, sqmil, acre, hectare
- Volume 	m3, litre (l, L, lt, liter), cc, cuin, cuft, cuyd, teaspoon, tablespoon
- Liquid volume 	minim, fluiddram (fldr), fluidounce (floz), gill (gi), cup (cp), pint (pt), quart (qt), gallon (gal), beerbarrel (bbl), oilbarrel (obl), hogshead, drop (gtt)
- Angles 	rad (radian), deg (degree), grad (gradian), cycle, arcsec (arcsecond), arcmin (arcminute)
- Time 	second (s, secs, seconds), minute (min, mins, minutes), hour (h, hr, hrs, hours), day (days), week (weeks), month (months), year (years), decade (decades), century (centuries), millennium (millennia)
- Frequency 	hertz (Hz)
- Mass 	gram(g), tonne, ton, grain (gr), dram (dr), ounce (oz), poundmass (lbm, lb, lbs), hundredweight (cwt), stick, stone
- Electric current 	ampere (A)
- Temperature 	kelvin (K), celsius (degC), fahrenheit (degF), rankine (degR)
- Amount of substance 	mole (mol)
- Luminous intensity 	candela (cd)
- Force 	newton (N), dyne (dyn), poundforce (lbf), kip
- Energy 	joule (J), erg, Wh, BTU, electronvolt (eV)
- Power 	watt (W), hp
- Pressure 	Pa, psi, atm, torr, bar, mmHg, mmH2O, cmH2O
- Electricity and magnetism 	ampere (A), coulomb (C), watt (W), volt (V), ohm, farad (F), weber (Wb), tesla (T), henry (H), siemens (S), electronvolt (eV)
- Binary 	bits (b), bytes (B)
`,
  //BLOCK CONVERT_INTO_UNIT
  CONVERT_INTO_UNIT_MESSAGE: "conversion of %1 into %2",
  CONVERT_INTO_UNIT_TOOLTIP: "Returns value converted into the new unit.",

  ////////////////////////////
  //BLOCKS FRACTION
  FRACTION_MESSAGE: "fraction %1 / %2",
  FRACTION_TOOLTIP:
    "Returns a fraction defined by its numerator and denominator.",

  CONVERT_INTO_FRACTION_MESSAGE: "convert %1 into fraction",
  CONVERT_INTO_FRACTION_TOOLTIP: "Returns a number in its fraction form",

  FRACTION_NUMERATOR_DENOMINATOR_MESSAGE: "%1 of %2",
  FRACTION_NUMERATOR_DENOMINATOR_NUMERATOR: "numerator",
  FRACTION_NUMERATOR_DENOMINATOR_DENOMINATOR: "denominator",
  FRACTION_NUMERATOR_DENOMINATOR_TOOLTIP:
    "Returns numerator or denominator of a fraction.",

  SIMPLIFY_FRACTION_MESSAGE: "irreducible fraction of %1",
  SIMPLIFY_FRACTION_TOOLTIP:
    "Returns the irreducible fraction form of the fraction",

  //MATH MATRIX

  //TABLE_DATA
  DATA_TABLE_TITLE: "data table",
  DATA_TABLE_TOOLTIP:
    "Returns a table in matrix format made from the defined values",
  //NUMPY MATRIX
  NUMPY_SQUARE_MATRIX_TITLE: "matrix",
  MATRIX_TABLE_TOOLTIP: "Returns a matrix made from the defined values",
  //MATRIX
  MATRIX_MESSAGE: "create a matrix with %1 %2",
  MATRIX_TOOLTIP:
    "Returns a matrix constructed from the text [[1,2],[3,4]] or from an already defined list.",
  //MATRIX3PARAMS (MATRIX_RANDOM)
  MATRIX3PARAMS_MESSAGE:
    "create a matrix of %1 rows and %2 columns filled with %3",
  MATRIX3PARAMS_TOOLTIP: `Returns a matrix of the defined size filled with a particular value or with the result of a calculation.`,
  //MATRIXDETERMINANT
  MATRIXDETERMINANT_MESSAGE: "determinant of the matrix %1",
  MATRIXDETERMINANT_TOOLTIP: "Returns the determinant of the matrix.",
  //MATRIX_SUM
  MATRIX_SUM_MESSAGE: "sum of a matrix %1 and the matrix %2",
  MATRIX_SUM_TOOLTIP: "Returns the sum of the two matrices.",
  //MATRIX_MULTIPLICATION
  MATRIX_MULTIPLICATION_MESSAGE: "matrix product of matrix %1 with matrix %2",
  MATRIX_MULTIPLICATION_TOOLTIP: "Returns the matrix product of two matrices.",
  //MATRIX_SCALAR
  MATRIX_SCALAR_MESSAGE: "product(scalar) of the number %1 and the matrix %2",
  MATRIX_SCALAR_TOOLTIP: "Returns the product of a scalar and a matrix.",
  //MATRIX_SHORT_SET
  MATRIX_SHORT_SET_MESSAGE: "%1[%2,%3]=%4",
  MATRIX_SHORT_SET_TOOLTIP: "Sets a value in a matrix at index i,j",
  //MATRIX_SHORT_GET
  MATRIX_SHORT_GET_MESSAGE: "%1[%2,%3]",
  MATRIX_SHORT_GET_TOOLTIP: "Returns a matrix element at index i,j",

  //////////////////LISTS
  //RANDOMLIST
  RANDOMLIST_MESSAGE: "create a list of length %1 and filled with %2",
  RANDOMLIST_TOOLTIP: `Returns a list of the defined size filled with a particular value or with the result of a calculation.`,
  //LISTSSHUFFLE
  SHUFFLELIST_MESSAGE: "🎲 shuffle randomly the elements of the list %1",
  SHUFFLELIST_TOOLTIP: "Contains the list in which the elements will be mixed.",
  //BLOCK DELETE_DUPLICATE
  DELETE_DUPLICATES_MESSAGE: "delete duplicates in the list %1",
  DELETE_DUPLICATES_TOOLTIP: "Removes duplicates from the list.",
  //BLOCK DELETE_ELEMENT_FROM_LIST
  DELETE_ELEMENT_FROM_LIST_MESSAGE: "delete item %1 in list %2",
  DELETE_ELEMENT_FROM_LIST_TOOLTIP: "Delete an item in a list.",
  //BLOCK COUNT_SAME_ELEMENT_LIST
  COUNT_SAME_ELEMENT_LIST_MESSAGE:
    "counts the number of occurrences of %1 in the list %2",
  COUNT_SAME_ELEMENT_LIST_TOOLTIP:
    "Returns the number of occurrences of an element in a list.",
  //LIST_SHORT_SET
  LIST_SHORT_SET_MESSAGE: "%1[%2]=%3",
  LIST_SHORT_SET_TOOLTIP: "Sets a value in a list at index i",
  //LIST_SHORT_GET
  LIST_SHORT_GET_MESSAGE: "%1[%2]",
  LIST_SHORT_GET_TOOLTIP: "Returns a list element at index i",

  //CATMEDIA
  //BLOCK ELEDA_IMAGE
  IMAGE_MESSAGE: "🏞 image %1 URL %2 legend %3 %4options ",
  IMAGE_WIDTH: "Width",
  IMAGE_HEIGHT: "Height",
  IMAGE_TOOLTIP: `Displays an image with a link.
    - URL: it contains the address or the link of the image.`,

  IMAGE_DOCUMENTATION: `
Displays an image with a link.
    - URL : it contains the address or the link of the image
  
    options :
    - Width : allows you to define a fixed width for the image.
    - Height: Allows you to set a fixed height for the image.
Displays an image with a link.
`,

  //BLOCK ELEDA_VIDEO
  VIDEO_MESSAGE: "📽 video %1 integration code %2 legend %3",
  VIDEO_TOOLTIP: `Displays a video with an embed code.
    - Integration code: it contains the integration code of the video (right click on a video, then copy the integration code).`,

  //BLOCK ELEDA AUDIO
  ELEDA_AUDIO_MESSAGE:
    "♬ audio %1 number of repetition %2 Link (mp3, mp4...) %3 legend %4",

  //BLOCK TABLE MATRIX
  TABLE_MATRIX_TITLE: "table",
  GRID_MATRIX_TITLE: "grid",
  TABLE_MATRIX_TOOLTIP: "Create an HTML table",

  //BLOCK TABLE (HTML) COLUMN
  TABLE_COLUMN_TITLE: "column(s)",
  TABLE_COLUMN_TOOLTIP:
    "Créer une colonne qui va générer des cellules pour le tableau",

  //
  TEXT_JOIN_TITLE: "create text with",
  TEXT_JOIN_HELPURL: "",
  TEXT_JOIN_TOOLTIP: "",

  //block eleda_alignment
  ELEDA_ALIGNMENT_TEXT: "alignment",

  //CLONE
  CLONE_MESSAGE: "clone of %1",

  //Backpack
  EMPTY_BACKPACK: "Empty",
  REMOVE_FROM_BACKPACK: "Remove from Backpack",
  COPY_TO_BACKPACK: "Copy to Backpack",
  COPY_ALL_TO_BACKPACK: "Copy All Blocks to Backpack",
  PASTE_ALL_FROM_BACKPACK: "Paste All Blocks from Backpack",

  //Dictionary
  DICTIONARY_TITLE: "Dictionary",
  DICTIONARY_MESSAGE: "dictionary %1 %2",
  DICTIONARY_HELPURL: "",
  DICTIONARY_TOOLTIP: "",

  //random_verb
  RANDOM_VERB_TITLE: "Random verb",
  RANDOM_VERB_MESSAGE: "🎲 Random verb from dictionary %1 %2 from %3 group",
  RANDOM_VERB_HELPURL: "",
  RANDOM_VERB_TOOLTIP: "",

  //selected verb
  SELECTED_VERB_TITLE: "Verb",
  SELECTED_VERB_MESSAGE: "verb from dictionary %1 %2 %3 with infinitive %4",
  SELECTED_VERB_HELPURL: "",
  SELECTED_VERB_TOOLTIP: "",

  //verb_getAttribute
  VERB_GETATTRIBUTE_TITLE: "Get verb's attribute",
  VERB_GETATTRIBUTE_MESSAGE: "get le %1 from verb %2",
  VERB_GETATTRIBUTE_HELPURL: "",
  VERB_GETATTRIBUTE_TOOLTIP: "",

  //conjugate_verb
  CONJUGATE_VERB_TITLE: "Get verb's conjugations",
  CONJUGATE_VERB_MESSAGE:
    "get conjugaisons from verb %1 of %2 from dictionary %3",
  CONJUGATE_VERB_HELPURL: "",
  CONJUGATE_VERB_TOOLTIP: "",

  //selected_determinantDefInfDemons
  SELECTED_DETERMINANTDEFINFFEMONS_TITLE: "Get determinant of name",
  SELECTED_DETERMINANTDEFINFFEMONS_MESSAGE:
    "determinant from dictionary %1 %2 with type %3 for name %4",
  SELECTED_DETERMINANTDEFINFFEMONS_HELPURL: "",
  SELECTED_DETERMINANTDEFINFFEMONS_TOOLTIP: "",

  //determinantDefInfDemons_getAttribute
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TITLE: "Get attribute of determinant",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_MESSAGE:
    "get %1 from determinant (in)défini ou démonstratif %2",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_HELPURL: "",
  DETERMINANTDEFINFDEMONS_GETATTRIBUTE_TOOLTIP: "",

  //selected_determinantPoss
  SELECTED_DETERMINANTPOSS_TITLE: "Determinant possessif of name",
  SELECTED_DETERMINANTPOSS_MESSAGE:
    "determinant possessive from dictionary %1 %2 for name %3",
  SELECTED_DETERMINANTPOSS_HELPURL: "",
  SELECTED_DETERMINANTPOSS_TOOLTIP: "",

  //determinantPoss_getListForNumber
  DETERMINANTPOSS_GETLISTFORNUMBER_TITLE: "Liste des déterminants possessif",
  DETERMINANTPOSS_GETLISTFORNUMBER_MESSAGE:
    "get list of %1 of déterminant possessive %2",
  DETERMINANTPOSS_GETLISTFORNUMBER_HELPURL: "",
  DETERMINANTPOSS_GETLISTFORNUMBER_TOOLTIP: "",

  //random_name
  RANDOM_NAME_TITLE: "Random name",
  RANDOM_NAME_MESSAGE: "🎲 random name from dictionary %1 %2 with genre %3",
  RANDOM_NAME_HELPURL: "",
  RANDOM_NAME_TOOLTIP: "",

  //selected_name
  SELECTED_NAME_TITLE: "Name",
  SELECTED_NAME_MESSAGE: "name from dictionary %1 %2 titled %3",
  SELECTED_NAME_HELPURL: "",
  SELECTED_NAME_TOOLTIP: "",

  //name_getAttribute
  NAME_GETATTRIBUTE_TITLE: "Get attribute of name",
  NAME_GETATTRIBUTE_MESSAGE: "get %1 from name %2",
  NAME_GETATTRIBUTE_HELPURL: "",
  NAME_GETATTRIBUTE_TOOLTIP: "",

  //random_adjective
  RANDOM_ADJECTIVE_TITLE: "Random adjective",
  RANDOM_ADJECTIVE_MESSAGE: "🎲 random adjective from dictionary %1",
  RANDOM_ADJECTIVE_HELPURL: "",
  RANDOM_ADJECTIVE_TOOLTIP: "",

  //selected_adjective
  SELECTED_ADJECTIVE_TITLE: "Adjective",
  SELECTED_ADJECTIVE_MESSAGE: "adjective from dictionary %1 %2 titled %3",
  SELECTED_ADJECTIVE_HELPURL: "",
  SELECTED_ADJECTIVE_TOOLTIP: "",

  //adjective_getAttribute
  ADJECTIVE_GETATTRIBUTE_TITLE: "Get attribute of adjective",
  ADJECTIVE_GETATTRIBUTE_MESSAGE: "get %1 of adjective %2",
  ADJECTIVE_GETATTRIBUTE_HELPURL: "",
  ADJECTIVE_GETATTRIBUTE_TOOLTIP: "",

  //split_into_words_letters
  SPLIT_INTO_WORDS_LETTERS_TITLE: "Split text",
  SPLIT_INTO_WORDS_LETTERS_MESSAGE: "Split texte %1 %2 into %3",
  SPLIT_INTO_WORDS_LETTERS_HELPURL: "",
  SPLIT_INTO_WORDS_LETTERS_TOOLTIP: "",

  //french Gender and Number
  MALE: "male",
  FEMALE: "female",
  SINGULAR: "singular",
  PLURAL: "plural",
  RANDOM: "random",
  GENDER: "gender",
  NUMBER: "number",
  WORDS: "words",
  LETTERS: "letters",

  //TEXT_CHANGECASE
  TEXT_CHANGECASE_OPERATOR_FIRSTLETTERCASE: "to Title case for the first word",

  //LOGIC CATEGORY (ADD DOC TO BLOCKLY EXISTING BLOCKS)
  LOGIC_COMPARE_DOCUMENTATION:
    "Return true if both inputs are equal. = and ≠ can be used to also compare geometric objects.",
};
